import { render, staticRenderFns } from "./MeasurementForm.vue?vue&type=template&id=3df04cfe&scoped=true&"
import script from "./MeasurementForm.vue?vue&type=script&lang=js&"
export * from "./MeasurementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df04cfe",
  null
  
)

export default component.exports